export default "__VITE_ASSET__$tMZGZ2W__"